import {CollectionViewer, DataSource} from '@angular/cdk/collections';
import {AuditLog, AuditLogFilterValues} from './audit-log.model';
import {NgZone} from '@angular/core';
import {DialogService} from '../services/dialog.service';
import {AuditLogService} from '../services/audit-log.service';
import {BehaviorSubject, Observable} from 'rxjs';
import {finalize} from 'rxjs/operators';
import {DEFAULT_LIBRARIES_ITEMS_PAGE_NUMBER} from '../constants/library-constants';
import {PolicyType} from '../constants/retention-constants';

export class AuditLogDataSource implements DataSource<AuditLog> {

  private auditLogsSubject = new BehaviorSubject<AuditLog[]>([]);
  private loadingSubject = new BehaviorSubject<boolean>(false);
  public loading$ = this.loadingSubject.asObservable();
  public auditLogs: AuditLog[] = [];

  constructor(private auditLogService: AuditLogService, private ngZone: NgZone, private dialogService: DialogService) {
  }

  connect(collectionViewer: CollectionViewer): Observable<AuditLog[]> {
    return this.auditLogsSubject.asObservable();
  }

  disconnect(collectionViewer: CollectionViewer): void {
    this.auditLogsSubject.complete();
    this.loadingSubject.complete();
  }

  loadAuditLogs(limit: number, offset: number, filters: AuditLogFilterValues, retentionType: PolicyType): void {
    this.loadingSubject.next(true);
    this.auditLogService.list(limit, offset, filters, retentionType).pipe(
      finalize(() => this.loadingSubject.next(false))
    ).subscribe({
      next: (resp) => {
        if (!resp) {
          resp = [];
        }
        this.auditLogsSubject.next(resp);
        this.auditLogs.push(...resp);
      }, error: () => {
        // e.g. the BQ dataset of this retention type is not configured -> show an empty table instead of an error
        this.auditLogsSubject.next([]);
      }
    });
  }

  public loadAuditLogPage(eventPageIndex: number,
                          filters: AuditLogFilterValues,
                          retentionType: PolicyType,
                          pageIndex = 0,
                          pageSize = DEFAULT_LIBRARIES_ITEMS_PAGE_NUMBER): void {

    const start = eventPageIndex * pageSize;
    const end = (eventPageIndex + 1) * pageSize;

    if (start >= this.auditLogs.length) {
      this.loadAuditLogs(pageSize, eventPageIndex * pageSize, filters, retentionType);
    } else {
      this.auditLogsSubject.next(this.auditLogs.slice(start, end));
    }
  }

  init(limit: number, offset: number, filters: AuditLogFilterValues, retentionType: PolicyType): void {
    this.auditLogs = [];
    this.loadAuditLogs(limit, offset, filters, retentionType);
  }
}
